import { createContext } from "react";
import { AppBloc } from "@/services/base-bloc";

export const AppContext = createContext<AppBloc>(new AppBloc());
